import React from 'react';
import { connect } from 'react-redux';
import {
  pageRequest,
  onConfirmRemoveApp,
  onCancelRemoveApp,
  onClickRemoveApp,
} from 'actions/openPlatform/myApp';
import PageWrapper from 'components/wrappers/pages/PageWrapper';
import { formValueSelector } from 'redux-form';
import includes from 'lodash/includes';
import lowerCase from 'lodash/lowerCase';
import ConfirmModal from 'components/ConfirmModal';
import NoDataDisplay from 'components/NoDataAndLoading';
import * as marketplaceUtil from 'utils/marketplace';
import * as clevertapOpenPlatformMyApp from 'clevertap/openPlatform/myApp';
import { setUserProfile } from 'clevertap/login';
import get from 'lodash/get';
import withFeatureFlags from 'hocs/withFeatureFlags';
import moment from 'moment';
import { refreshSession, getTokenExpiry } from 'utils/auth';
import Title from '../Title';
import AppRow from '../AppRow';
import BuiltWithMoka from './BuiltWithMoka';
import styles from './MyApp.css';
import ActionBar from '../ActionBar';

class MyApp extends React.Component {
  componentDidMount() {
    const { moka } = this.props;

    if (moka.loggedIn) {
      setClevertapUserProfile(moka);
    }
    this.props.dispatch(pageRequest({ userId: moka.user.id }));
  }

  render() {
    const {
      apps,
      removedApp,
      showConfirmRemoveModal,
      submit,
      business,
    } = this.props;
    const showLoadingSpinner = submit === 'get_authorized_apps';
    return (
      <PageWrapper>
        <ActionBar
          location={this.props.location}
          onChangeField={this._onChangeField}
          fields={'keyword'}
        />
        {apps.length > 0 && (
          <div className={styles.appListWrapper}>
            <Title title="My Apps" />
            <div className={styles.appList}>
              {apps.map((app, index) => {
                const keyword = lowerCase(
                  this.props.searchValues.keyword || ''
                );
                const show = includes(lowerCase(app.name), keyword);
                return (
                  show && (
                    <AppRow
                      key={index}
                      app={app}
                      business={business}
                      onClickRemove={this._onClickRemoveModal}
                      onClickLaunch={this._onClickLaunch}
                      launchText="Launch"
                      defaultStyle={false}
                    />
                  )
                );
              })}
            </div>
          </div>
        )}
        {!apps.length && (
          <div className={styles.appListWrapper}>
            <NoDataDisplay
              showLoadingSpinner={showLoadingSpinner}
              noDataToDisplay
              title={'No Connected Apps'}
              description={"You haven't connected any apps yet."}
              linkLabel={'Moka App Marketplace'}
              linkUrl={'/apps/app-market'}
              linkLabelPrefix={"See what's available in "}
              linkTarget={''}
              onClickTrackLink={this._noDataTrackLink}
            />
          </div>
        )}
        <div className={styles.builtWithMokaWrapper}>
          <BuiltWithMoka />
        </div>
        <ConfirmModal
          onHide={this._onHideRemoveModal}
          showModal={showConfirmRemoveModal}
          title="Revoke Permission"
          description={`Are you sure you want to revoke permission for ${removedApp &&
            removedApp.name} to access your Moka POS account?`}
          onConfirm={this._onConfirmRemoveModal}
          confirmTitle="Revoke"
          cancelTitle="Cancel"
          baseColor="danger"
          onCancel={this._onCancelRemoveModal}
        />
      </PageWrapper>
    );
  }

  isSessionExpiredInTenMinutes = () => {
    return moment(getTokenExpiry()).diff(moment(), 'minute') <= 10;
  };

  _openNewWindow = app => {
    const { enableCmpLogin } = this.props;

    const url = enableCmpLogin
      ? marketplaceUtil.generateCMPExternalURL(app)
      : marketplaceUtil.generateExternalURL(app);
    window.open(url, '_blank');
  };

  _openExternalAppURL = app => {
    const { enableCmpLogin } = this.props;

    if (enableCmpLogin && this.isSessionExpiredInTenMinutes()) {
      refreshSession().then(() => this._openNewWindow(app));
    } else {
      this._openNewWindow(app);
    }
  };

  _noDataTrackLink = () => {
    clevertapOpenPlatformMyApp.myAppLink();
  };

  _onClickLaunch = ({ app }) => {
    clevertapOpenPlatformMyApp.myAppLaunch({ uid: app.uid, name: app.name });
    this._openExternalAppURL(app);
  };

  _onChangeField = () => {};

  _onHideRemoveModal = () => {
    this.props.dispatch(onCancelRemoveApp());
    clevertapOpenPlatformMyApp.myAppRevokeClosed();
  };

  _onCancelRemoveModal = () => {
    this.props.dispatch(onCancelRemoveApp());
    clevertapOpenPlatformMyApp.myAppRevokeCancel();
  };

  _onConfirmRemoveModal = () => {
    const { removedApp, apps, moka } = this.props;

    this.props.dispatch(
      onConfirmRemoveApp({
        app: removedApp,
        previousApps: apps,
        userId: get(moka, 'user.id', null),
      })
    );
    setClevertapUserProfile(moka);
  };

  _onClickRemoveModal = ({ app }) => {
    this.props.dispatch(onClickRemoveApp({ app }));
  };
}
const selector = formValueSelector('search');

function mapStateToProps(state) {
  const {
    apps,
    removedApp,
    showConfirmRemoveModal,
    submit,
    business,
  } = state.openPlatform.myApp;
  const { moka } = state;
  return {
    apps,
    business,
    removedApp,
    showConfirmRemoveModal,
    submit,
    moka,
    searchValues: {
      keyword: selector(state, 'keyword'),
    },
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function setClevertapUserProfile(moka) {
  const {
    user: mokaUser,
    businessTypesState: businessTypes,
    businessCategoriesAllState: businessCategories,
  } = moka;
  setUserProfile({
    profile: mokaUser,
    businessTypes,
    businessCategories,
  });
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(MyApp);

function mapFlagsToProps(flags) {
  return {
    enableCmpLogin: flags.enableCmpLogin,
  };
}

export default withFeatureFlags(mapFlagsToProps)(connected);
